import {
  GetCartQuery,
  GetCartQueryVariables,
} from "./shopify-storefront.graphql";
import { ShopifyStorefrontClient } from "./storefront-client";

const CART_DATA_FRAGMENT = /* GraphQL */ `
  fragment CartData on Cart {
    id
    totalQuantity
    checkoutUrl
    cost {
      totalAmount {
        amount
        currencyCode
      }
    }
    lines(first: 250) {
      edges {
        node {
          id
          quantity
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }
          merchandise {
            ... on ProductVariant {
              id
              image {
                originalSrc
              }
              title
              price {
                amount
                currencyCode
              }
              product {
                title
                vendor
              }
            }
          }
        }
      }
    }
  }
`;

const getCartQuery = /* GraphQL */ `
  query GetCart($id: ID!) {
    cart(id: $id) {
      ...CartData
    }
  }
  ${CART_DATA_FRAGMENT}
`;

export interface CartLine {
  node: {
    id: string;
    cost: {
      totalAmount: {
        amount: string;
        currencyCode: string;
      };
    };
    merchandise: {
      id: string;
      image?: {
        originalSrc: string;
      } | null;
      price: {
        amount: string;
        currencyCode: string;
      };
      product: {
        title: string;
        vendor: string;
      };
      title: string;
    };
    quantity: number;
  };
}

export interface CartData {
  id: string;
  totalQuantity: number;
  checkoutUrl: string;
  cost: {
    totalAmount: {
      amount: string;
      currencyCode: string;
    };
  };
  lines: {
    edges: CartLine[];
  };
}

export async function getCart(
  client: ShopifyStorefrontClient,
  id: string,
): Promise<CartData> {
  const { data, errors } = await client.request<
    GetCartQuery,
    GetCartQueryVariables
  >(getCartQuery, { id });

  if (errors) {
    throw errors;
  }

  if (!data?.cart) {
    throw new Error("Cart not found");
  }
  return data.cart;
}
